import React from 'react';
import Button from './Button';
import './EmptyState.css';

function EmptyState({
  icon = '*',
  headline,
  title,
  body,
  description,
  primaryCtaLabel = '',
  onPrimaryCta = null,
  actions,
  className = '',
  compact = false
}) {
  const resolvedHeadline = title || headline;
  const resolvedBody = description || body;

  return (
    <div className={`empty-state ${compact ? 'empty-state--compact' : ''} ${className}`.trim()}>
      <span className="empty-state__icon" aria-hidden>{icon}</span>
      <h3 className="empty-state__headline">{resolvedHeadline}</h3>
      {resolvedBody ? <p className="empty-state__body">{resolvedBody}</p> : null}
      {actions ? (
        <div className="empty-state__actions">{actions}</div>
      ) : primaryCtaLabel && typeof onPrimaryCta === 'function' ? (
        <Button size="sm" variant="secondary" onClick={onPrimaryCta} className="empty-state__cta">
          {primaryCtaLabel}
        </Button>
      ) : null}
    </div>
  );
}

export default EmptyState;
